import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { Box, Typography } from '@mui/material'

interface CheapestBookingProps {
    title: string
    summary: string
    bullets: string[]
}

const CheapestBooking: React.FC<CheapestBookingProps> = ({ title, summary, bullets }) => {
    return (
        <Box sx={{ mb: 3 }}>
            <Typography
                component="h2"
                variant="h6"
                sx={{ fontWeight: 600, fontSize: { xs: '1rem', md: '1.25rem' }, mb: 1.5 }}
            >
                {title}
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8, mb: 2 }}>
                {summary}
            </Typography>
            <Box component="ul" sx={{ m: 0, p: 0, listStyle: 'none' }}>
                {bullets.map((bullet, index) => (
                    <Box
                        component="li"
                        key={index}
                        sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 1 }}
                    >
                        <CheckCircleOutlineIcon
                            sx={{ fontSize: 18, color: 'success.main', mt: 0.3, flexShrink: 0 }}
                        />
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            {bullet}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    )
}

export default CheapestBooking
export type { CheapestBookingProps }
